/**
 * Shared state shape + helpers for the welcome-page editor. Kept separate from
 * the component module so the editor file can export only components (Fast
 * Refresh / react-refresh rule).
 */

import type { WelcomePageContentBlock } from '@/shared/components/welcome-banner'

export interface WelcomePageState {
  /**
   * Master on/off switch for the whole welcome page. When false the public
   * consumer page is taken offline (the backend 404s it) and the admin editor
   * is hidden. Absent on the wire means "live" (backward compatible with pages
   * authored before the toggle existed).
   */
  enabled: boolean
  include_faqs: boolean
  include_contact: boolean
  content_blocks: WelcomePageContentBlock[]
}

export const EMPTY_WELCOME_PAGE: WelcomePageState = {
  enabled: false,
  include_faqs: false,
  include_contact: false,
  content_blocks: [],
}

/** Normalise a raw stored welcome page (or null) into editor state. */
export function normaliseWelcomePage(
  wp: Partial<WelcomePageState> | null | undefined,
): WelcomePageState {
  return {
    // Explicit boolean wins; otherwise a previously-authored page (any stored
    // object) stays enabled, and a brand-new tenant (null) defaults to off.
    enabled: typeof wp?.enabled === 'boolean' ? wp.enabled : Boolean(wp),
    include_faqs: Boolean(wp?.include_faqs),
    include_contact: Boolean(wp?.include_contact),
    content_blocks: wp?.content_blocks ?? [],
  }
}
